import { render } from "./TagsPage.vue?vue&type=template&id=79c61f2a&ts=true"
import script from "./TagsPage.vue?vue&type=script&lang=ts"
export * from "./TagsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__